module.exports = __webpack_public_path__ + "static/media/GoHaus.png.79f57c67.webp";